<template>
    <el-dialog
        :title="$t('Visit File Library')"
        append-to-body
        class="send-link-dialog"
        :close-on-click-modal="false"
        :visible.sync="show"
    >
        <div class="mb-10px">
            <el-input
                :placeholder="$t('Type to filter')"
                v-model="searchQuery"
                prefix-icon="el-icon-search"
                clearable
                class="filter-input"
                size="small"
            ></el-input>
            <template v-if="imageFiles && imageFiles.length > 0">
                <span class="form-label">{{ $t('Image') }}</span>

                <el-upload
                    ref="uploadImage"
                    class="selector-file-upload-image"
                    list-type="picture-card"
                    action="/mobile/file/upload"
                    :file-list="imageFiles"
                    :auto-upload="false"
                >
                    <div slot="file" slot-scope="{ file }">
                        <img
                            v-if="!file.uploading"
                            class="el-upload-list__item-thumbnail"
                            :src="getImageSrc(file)"
                            alt
                        />
                        <div v-else class="position-relative text-align-center">
                            <div class="position-absolute w-100 h-100">
                                <i class="fa fa-spinner fa-spin" style="margin-top: 40%"></i>
                            </div>
                        </div>
                        <div
                            v-if="!file.uploading"
                            class="position-absolute"
                            style="top: 0; right: 10px; font-size: 20px; cursor: pointer"
                        >
                            <span @click="handleImageTag(file)">
                                <i class="fa fa-tag"></i>
                            </span>
                            <span>
                                <el-checkbox v-model="file.checked"></el-checkbox>
                            </span>
                        </div>
                    </div>
                </el-upload>
            </template>
            <template v-if="videoFiles && videoFiles.length > 0">
                <span class="form-label">{{ $t('Video') }}</span>

                <el-upload
                    ref="upload"
                    class="selector-file-upload-video"
                    list-type="picture-card"
                    action="/mobile/file/upload"
                    multiple
                    accept="video/*"
                    :file-list="videoFiles"
                    :auto-upload="false"
                >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                        <video v-if="!file.uploading" controls>
                            <source :src="getMediaSrc(file)" />
                            {{ $t('Your browser does not support HTML5 video.') }}
                        </video>
                        <div v-else class="position-relative text-align-center">
                            <div class="position-absolute w-100 h-100">
                                <i class="fa fa-spinner fa-spin" style="margin-top: 40%"></i>
                            </div>
                        </div>
                        <div
                            v-if="!file.uploading"
                            class="position-absolute"
                            style="top: 0; right: 10px; font-size: 20px; cursor: pointer"
                        >
                            <span @click="handleImageTag(file)">
                                <i class="fa fa-tag"></i>
                            </span>
                            <span>
                                <el-checkbox v-model="file.checked"></el-checkbox>
                            </span>
                        </div>
                    </div>
                </el-upload>
            </template>
            <template v-if="audioFiles && audioFiles.length > 0">
                <span class="form-label">{{ $t('Audio') }}</span>
                <el-upload
                    ref="uploadAudio"
                    class="selector-file-upload-audio"
                    list-type="picture-card"
                    action="/mobile/file/upload"
                    multiple
                    accept="audio/*"
                    :file-list="audioFiles"
                    :auto-upload="false"
                >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                        <audio v-if="!file.uploading" style="width: 250px; height: 96px" controls>
                            <source :src="getMediaSrc(file)" />
                            {{ $t('Your browser does not support HTML5 audio.') }}
                        </audio>
                        <div v-else class="position-relative text-align-center">
                            <div class="position-absolute w-100 h-100">
                                <i class="fa fa-spinner fa-spin" style="margin-top: 40%"></i>
                            </div>
                        </div>
                        <div
                            v-if="!file.uploading"
                            class="position-absolute"
                            style="top: 0; right: 10px; font-size: 20px; cursor: pointer"
                        >
                            <span @click="handleImageTag(file)">
                                <i class="fa fa-tag"></i>
                            </span>
                            <span>
                                <el-checkbox v-model="file.checked"></el-checkbox>
                            </span>
                        </div>
                    </div>
                </el-upload>
            </template>
            <template v-if="otherFiles && otherFiles.length > 0">
                <span class="form-label">{{ $t('Document') }}</span>
                <el-upload
                    ref="uploadDocument"
                    class="selector-file-upload-docs"
                    list-type="picture-card"
                    action="/mobile/file/upload"
                    multiple
                    :file-list="otherFiles"
                    :auto-upload="false"
                >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                        <div v-if="file.uploading" class="position-relative text-align-center">
                            <div class="position-absolute w-100 h-100">
                                <i class="fa fa-spinner fa-spin" style="margin-top: 40%"></i>
                            </div>
                        </div>
                        <template v-else>
                            <a
                                class="display-block text-align-center w-100 h-100"
                                :href="getMediaSrc(file)"
                                :title="file.path.split('/').pop()"
                                target="_blank"
                                style="line-height: 96px"
                            >
                                <i class="fa fa-file"></i>
                            </a>
                            <div
                                class="position-absolute"
                                style="top: 0; right: 10px; font-size: 20px; cursor: pointer"
                            >
                                <span @click="handleImageTag(file)">
                                    <i class="fa fa-tag"></i>
                                </span>
                                <span>
                                    <el-checkbox v-model="file.checked"></el-checkbox>
                                </span>
                            </div>
                        </template>
                    </div>
                </el-upload>
            </template>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onAddDocument" type="primary" size="small">{{
                $t('Add Files')
            }}</el-button>
            <el-button type="text" @click="onCloseImageTag" size="small">{{
                $t('Close')
            }}</el-button>
        </div>
        <imagetag
            v-if="imageTagModalVisible"
            v-model="imageTagModalVisible"
            :fileStorage="selectedFileStorage"
        ></imagetag>
    </el-dialog>
</template>

<script>
import FileStorageItem from '@/data/FileStorageItem';
import Collection from '@/lib/data/Collection';
import Model from '@/lib/data/Model';
import imagetag from './imagetag.vue';

export default {
    name: 'fileselectormodal',
    components: { imagetag },
    props: {
        value: null,
        visit_id: null,
        question: null,
        fileType: {
            // image,video,audio if null all
            type: String,
            default() {
                return 'all';
            },
        },
    },
    data() {
        return {
            searchQuery: null,
            imageTagModalVisible: false,
            selectedFileStorage: null,
            auth_token: Model.getAuthToken(),
            allvisitrelatedfiles: new Collection({
                model: FileStorageItem,
                url: '/mobile/visit/relatedfiles',
                params: {
                    visit_id: this.$props.visit_id,
                },
            }),
            visitrelatedfiles: [],
            fileList: new Collection({
                model: FileStorageItem,
                url: '/filemanager/getByIds',
            }),
        };
    },
    created() {
        const self = this;
        this.allvisitrelatedfiles.load(true, {
            params: {},
            beforesend: () => {
                self.loading = true;
            },
            complete: () => {
                self.loading = false;
            },
            success: () => {
                self.visitrelatedfiles = self.allvisitrelatedfiles;
                for (let index = 0, l = self.allvisitrelatedfiles.length; index < l; index += 1) {
                    const element = self.allvisitrelatedfiles[index];
                    // onceden checklenmis ve eklenmis olanlari checkle
                    if (self.fileList.map((item) => item.id).includes(element.id)) {
                        element.checked = true;
                    }
                }
            },
            failure: (op, response) => {
                self.loading = false;
                self.$notify.error({
                    title: self.$t('Error'),
                    message:
                        response && response.meta
                            ? self.$t(response.meta.display_message)
                            : self.$t('Errors occured, please try again later'),
                });
            },
        });

        if (
            this.question.control_type === 'Image' ||
            this.question.control_type === 'Video' ||
            this.question.control_type === 'Audio'
        ) {
            // sorunu kendisi dosya yuklemesi ise
            if (this.question.data.return_value) {
                const ids = this.question.data.return_value.split(',');
                this.fileList.load(true, {
                    params: {
                        ids,
                    },
                });
            }
        } else {
            // dosya eklenen bir soruysa
            const ids = this.question.data.docs.map((item) => item.file_storage_id);
            this.fileList.load(true, {
                params: {
                    ids,
                },
            });
        }
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        existingFileStorageItems() {
            if (
                this.question.control_type === 'Image' ||
                this.question.control_type === 'Video' ||
                this.question.control_type === 'Audio'
            ) {
                // sorunu kendisi dosya yuklemesi ise
                const ids = this.question.data.return_value.split(',');
                this.fileList.load(true, {
                    params: {
                        ids,
                    },
                });
                return this.question.data.docs;
            }
            // dosya eklenen bir soruysa
            return this.question.data.docs;
        },
        imageFiles() {
            if (this.fileType === 'all' || this.fileType === 'Image') {
                return this.visitrelatedfiles.filter((item) => this.isImage(item));
            }
            return null;
        },
        videoFiles() {
            if (this.fileType === 'all' || this.fileType === 'Video') {
                return this.visitrelatedfiles.filter((item) => this.isVideo(item));
            }
            return null;
        },
        audioFiles() {
            if (this.fileType === 'all' || this.fileType === 'Audio') {
                return this.visitrelatedfiles.filter((item) => this.isAudio(item));
            }
            return null;
        },
        otherFiles() {
            if (this.fileType === 'all' || this.fileType === 'Other') {
                return this.visitrelatedfiles.filter((item) => this.isDocument(item));
            }
            return null;
        },
    },
    watch: {
        'question.control_type': function (v) {
            if (v === 'Image' || v === 'Video' || v === 'Audio') {
                // sorunu kendisi dosya yuklemesi ise
                const ids = this.question.data.return_value.split(',');
                this.fileList.load(true, {
                    params: {
                        ids,
                    },
                });
            } else {
                // dosya eklenen bir soruysa
                this.fileList = this.question.data.docs;
            }
        },
        searchQuery() {
            if (this.queryTimer) {
                clearTimeout(this.queryTimer);
                // this.list.abortLoad()
            }
            this.queryTimer = setTimeout(() => {
                this.getList();
            }, 250);
        },
    },
    methods: {
        getImageSrc(file) {
            return `${window.location.origin}/file?id=${file.id}&auth_token=${this.auth_token}`;
        },
        getMediaSrc(file) {
            return `${window.location.origin}/file?id=${file.id}&auth_token=${this.auth_token}`;
        },
        handleImageTag(file) {
            this.selectedFileStorage = file;
            this.imageTagModalVisible = true;
        },
        onAddDocument() {
            // alert("onAddDocument")
            const selectedFiles = this.visitrelatedfiles.filter((file) => file.checked);
            const selectedFiles2 = [];

            for (let index = 0, l = selectedFiles.length; index < l; index += 1) {
                const element = selectedFiles[index];
                const file = { id: element.id, path: element.path, mime_type: element.mime_type };
                // onceden eklenmemisse ekle
                if (
                    this.question.control_type === 'Image' ||
                    this.question.control_type === 'Video' ||
                    this.question.control_type === 'Audio'
                ) {
                    selectedFiles2.push(file);
                }
                // form quesler icin yoksa ekle
                else if (!this.fileList.map((item) => item.id).includes(element.id)) {
                    this.question.data.docs.push(element);
                }
            }

            // form sonu dosyalar icin varolani ez
            if (
                this.question.control_type === 'Image' ||
                this.question.control_type === 'Video' ||
                this.question.control_type === 'Audio'
            ) {
                this.question.data.return_value = selectedFiles2.map((item) => item.id).join(',');
            }
            this.show = false;
        },
        onCloseImageTag() {
            this.show = false;
        },
        isImage(item) {
            return item.mime_type.indexOf('image/') > -1;
        },
        isVideo(item) {
            return item.mime_type.indexOf('video/') > -1;
        },
        isAudio(item) {
            return item.mime_type.indexOf('audio/') > -1;
        },
        isDocument(item) {
            return !this.isImage(item) && !this.isVideo(item) && !this.isAudio(item);
        },
        getList() {
            if (this.searchQuery) {
                this.visitrelatedfiles = this.allvisitrelatedfiles.filter(
                    (item) =>
                        item.tags
                            .map((tagItem) => tagItem.tag)
                            .filter(
                                (tagItem) =>
                                    tagItem.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >
                                    -1
                            ).length > 0
                );
            } else {
                this.visitrelatedfiles = this.allvisitrelatedfiles;
            }
        },
    },
};
</script>
<style lang="scss">
.selector-file-upload-video,
.selector-file-upload-audio {
    .el-upload-list__item {
        // width: 98px;
        height: 98px;
    }
}
.selector-file-upload-image,
.selector-file-upload-docs {
    .el-upload-list--picture-card .el-upload-list__item {
        width: 98px;
        height: 98px;
    }
}

.selector-file-upload-image,
.selector-file-upload-video,
.selector-file-upload-audio,
.selector-file-upload-docs {
    .el-upload {
        display: none;
    }
}

.document-upload-button {
    position: absolute;
    top: -36px;
    right: 3px;
    cursor: pointer;
}
.document-upload-dialog {
    .el-upload--picture-card {
        width: 98px;
        height: 98px;
        line-height: 96px;
    }
    .el-upload-list--picture-card .el-upload-list__item {
        width: 98px;
        height: 98px;
    }
}
.help-documents-button {
    position: absolute;
    top: -36px;
    right: 23px;
    cursor: pointer;
}
.help-documents-dialog {
    .el-card {
        width: 120px;
        height: 120px;

        .el-card__body {
            padding: 0;
            width: 100%;
            height: 100%;
            position: relative;

            .help-file-icon {
                display: block;
                width: 100%;
                height: 100%;
                line-height: 120px;
                text-align: center;
            }

            .help-file-name {
                display: block;
                position: absolute;
                width: 100%;
                bottom: 0;
                text-align: center;
                line-height: 32px;
                padding: 0 4px;
                cursor: default;
            }
        }
    }
}
</style>
